import { AllergenLink } from 'menu/components/Allergens';
import { CalorieAmountDisplay } from 'menu/components/Calories';
import { Keywords } from 'menu/components/Keywords';
import { getProductPortions } from 'menu/utils';
import { AztecProduct } from 'types/models';
import { getCalories } from 'utils';

interface ParentProductInfoProps {
  aztecProduct: AztecProduct;
}

export const ParentProductInfo: React.FC<ParentProductInfoProps> = ({
  aztecProduct,
}) => {
  const displayRecord =
    aztecProduct.displayRecords[aztecProduct.displayRecordId];
  const portions = getProductPortions(aztecProduct);

  const caloriePhrase = getCalories(displayRecord, portions);

  const showCalsOrKeywords =
    caloriePhrase ||
    (displayRecord?.keywords && displayRecord.keywords.length > 0);

  return (
    <div className="parent-product-info">
      {showCalsOrKeywords ? (
        <div className="calories-keywords">
          <CalorieAmountDisplay
            displayRecord={displayRecord}
            portions={portions}
          />
          {displayRecord?.keywords ? (
            <Keywords list={displayRecord.keywords} />
          ) : null}
        </div>
      ) : null}
      {displayRecord?.description ? (
        <p className="no-margin">{displayRecord.description}</p>
      ) : null}
      <AllergenLink />
    </div>
  );
};
